var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c(
        "div",
        {
          staticClass: "burguer",
          on: {
            click: function($event) {
              return _vm.setOpened(!_vm.opened)
            }
          }
        },
        [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "down", mode: "in-out" } },
        [
          _c("Notifications", {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.outside,
                expression: "outside"
              },
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showNotifications,
                expression: "showNotifications"
              }
            ]
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41458b80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41458b80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = null
// module chunks = 